/**
 * VIVI Economics Dynamic Wine Theme
 * jQuery + Popper.js + AOS + Retina.js + Custom Animations
 */

(function($) {
  'use strict';

  // Initialize everything when DOM is ready
  $(document).ready(function() {
    initMobileMenu();
    initScrollEffects();
    initAnimations();
    initNewsletterForm();
    initProductCards();
    initSmoothScroll();
    initLazyLoading();
    initCart();
  });

  /**
   * Mobile Menu with Animation
   */
  function initMobileMenu() {
    // Create toggle if doesn't exist
    if ($('.mobile-menu-toggle').length === 0) {
      $('.header-wrapper').append('<button class="mobile-menu-toggle" aria-label="Toggle Menu"><span>☰</span></button>');
    }

    $(document).on('click', '.mobile-menu-toggle', function() {
      $('.site-nav').toggleClass('active');
      $('body').toggleClass('menu-open');
      
      const $icon = $(this).find('span');
      $icon.text($('.site-nav').hasClass('active') ? '✕' : '☰');
    });

    // Close on outside click
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.site-nav, .mobile-menu-toggle').length) {
        $('.site-nav').removeClass('active');
        $('body').removeClass('menu-open');
        $('.mobile-menu-toggle span').text('☰');
      }
    });

    // Close on link click
    $('.site-nav a').on('click', function() {
      $('.site-nav').removeClass('active');
      $('.mobile-menu-toggle span').text('☰');
    });
  }

  /**
   * Scroll Effects
   */
  function initScrollEffects() {
    let lastScroll = 0;
    
    $(window).on('scroll', function() {
      const scrollTop = $(this).scrollTop();
      
      // Header shrink on scroll
      if (scrollTop > 50) {
        $('.site-header').addClass('scrolled');
      } else {
        $('.site-header').removeClass('scrolled');
      }

      // Parallax effect
      $('.hero-section, .image-banner').each(function() {
        const offset = $(this).offset().top;
        const yPos = -(scrollTop - offset) * 0.5;
        $(this).css('background-position', `center ${yPos}px`);
      });

      lastScroll = scrollTop;
    });
  }

  /**
   * Advanced Animations
   */
  function initAnimations() {
    // Intersection Observer for scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          $(entry.target).addClass('aos-animate');
        }
      });
    }, observerOptions);

    $('.product-card, .feature-card, .section-header').each(function() {
      observer.observe(this);
    });

    // Counter animations
    $('.counter').each(function() {
      const $this = $(this);
      const countTo = parseInt($this.text());
      
      $({ countNum: 0 }).animate({
        countNum: countTo
      }, {
        duration: 2000,
        easing: 'swing',
        step: function() {
          $this.text(Math.floor(this.countNum));
        }
      });
    });
  }

  /**
   * Newsletter Form
   */
  function initNewsletterForm() {
    $('.newsletter-form').on('submit', function(e) {
      const $form = $(this);
      const $button = $form.find('.btn');
      const $input = $form.find('.newsletter-input');
      const email = $input.val();

      if (!isValidEmail(email)) {
        e.preventDefault();
        showNotification('Please enter a valid email address', 'error');
        return;
      }

      // Show loading
      $button.prop('disabled', true).html('<span class="loading-spinner"></span> Subscribing...');
    });
  }

  /**
   * Product Card Interactions
   */
  function initProductCards() {
    // Hover effects
    $('.product-card').hover(
      function() {
        $(this).find('.product-image').css('transform', 'scale(1.1)');
      },
      function() {
        $(this).find('.product-image').css('transform', 'scale(1)');
      }
    );

    // Add to cart animation
    $('.product-card .btn-primary, .product-form button[name="add"]').on('click', function(e) {
      const $button = $(this);
      const $card = $button.closest('.product-card, .product-form');
      
      // Flying cart animation
      if ($card.find('.product-image, .product__media img').length) {
        const $image = $card.find('.product-image, .product__media img').first();
        const $flying = $image.clone();
        
        $flying.css({
          position: 'fixed',
          top: $image.offset().top,
          left: $image.offset().left,
          width: $image.width(),
          height: $image.height(),
          zIndex: 9999,
          opacity: 1,
          transition: 'all 1s cubic-bezier(0.4, 0, 0.2, 1)'
        }).appendTo('body');

        setTimeout(function() {
          $flying.css({
            top: '20px',
            left: '90%',
            width: '50px',
            height: '50px',
            opacity: 0
          });
        }, 50);

        setTimeout(function() {
          $flying.remove();
        }, 1050);
      }
    });
  }

  /**
   * Smooth Scroll
   */
  function initSmoothScroll() {
    $('a[href^="#"]').on('click', function(e) {
      const target = $(this.getAttribute('href'));
      
      if (target.length) {
        e.preventDefault();
        $('html, body').stop().animate({
          scrollTop: target.offset().top - 80
        }, 1000);
      }
    });
  }

  /**
   * Lazy Loading
   */
  function initLazyLoading() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            const $img = $(entry.target);
            const src = $img.data('src');
            
            if (src) {
              $img.attr('src', src).removeAttr('data-src');
              imageObserver.unobserve(entry.target);
            }
          }
        });
      });

      $('img[data-src]').each(function() {
        imageObserver.observe(this);
      });
    }
  }

  /**
   * Shopping Cart
   */
  function initCart() {
    // Update cart count
    function updateCartCount() {
      $.getJSON('/cart.js', function(cart) {
        $('.cart-count').text(cart.item_count);
      });
    }

    // Add to cart via AJAX
    $(document).on('submit', 'form[action="/cart/add"]', function(e) {
      e.preventDefault();
      
      const $form = $(this);
      const formData = $form.serialize();
      
      $.post('/cart/add.js', formData, function(item) {
        showNotification('Added to cart!', 'success');
        updateCartCount();
      }).fail(function() {
        showNotification('Error adding to cart', 'error');
      });
    });
  }

  /**
   * Utilities
   */
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function showNotification(message, type) {
    const $notification = $('<div class="notification"></div>')
      .addClass('notification-' + type)
      .text(message)
      .css({
        position: 'fixed',
        top: '20px',
        right: '20px',
        padding: '1rem 2rem',
        background: type === 'success' ? '#4CAF50' : '#f44336',
        color: 'white',
        borderRadius: '8px',
        zIndex: 10000,
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
        animation: 'slideIn 0.3s ease'
      });

    $('body').append($notification);

    setTimeout(function() {
      $notification.fadeOut(function() {
        $(this).remove();
      });
    }, 3000);
  }

  /**
   * Window Load
   */
  $(window).on('load', function() {
    $('body').addClass('loaded');
    
    // Trigger AOS refresh
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  });

})(jQuery);

/**
 * Vanilla JS for Critical Functions
 */
document.addEventListener('DOMContentLoaded', function() {
  // Add CSS animation class
  document.querySelectorAll('.product-card, .feature-card').forEach(function(el, index) {
    el.style.animationDelay = (index * 0.1) + 's';
  });
});
